import { render } from "./DashboardAdminVx.vue?vue&type=template&id=18b9c7f3&scoped=true"
import script from "./DashboardAdminVx.vue?vue&type=script&lang=js"
export * from "./DashboardAdminVx.vue?vue&type=script&lang=js"

import "./DashboardAdminVx.vue?vue&type=style&index=0&id=18b9c7f3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b9c7f3"]])

export default __exports__